// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__1GeI4","lastUpdated":"TermsOfService_lastUpdated__vGPI_"};